import(/* webpackMode: "eager" */ "/var/www/deemcee-frontend/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/deemcee-frontend/src/app/(root)/_components/DashboardSkeletonClient.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/deemcee-frontend/src/app/(root)/_components/EnrolmentListTable.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/deemcee-frontend/src/app/(root)/_components/StudentListTable.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/deemcee-frontend/src/components/dashboard/DarkStatCard.tsx");
